<template>
    <div>
        <section class="main">
            <div class="main__sidebar">
                <slot name="sidebar"/>
            </div>
            <div class="main__content" :class="{'no-margin': noMargin}">
                <slot/>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: { },
})
export default class LelySidebarLayout extends Vue {
    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    noMargin!: boolean;
}
</script>

<style lang="scss" scoped>
$sidebar-width: 170px;

.container {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.main {
    display: flex;
}

.main__sidebar {
    width: $sidebar-width;
    flex-shrink: 0;
}

.main__content {
    flex-grow: 1;
    max-width: calc(100vw - $sidebar-width);
    padding: 0 20px;

    &.no-margin {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}
</style>
